import connectGetter from '../connectGetter';

export default function isContactInErrorState(contact: connect.Contact): boolean {
  const contactState = connectGetter(contact, 'getState');

  return contactState?.type === connect.ContactStateType.ERROR;
}
